module.exports = __webpack_public_path__ + "static/media/press8.734c84e2.jpg";